// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___2OMa_","page":"style__page___3wh58","title":"style__title___1G_S5","qrContainer":"style__qrContainer___1NwCD","errorContainer":"style__errorContainer___1it8-","deleteModelContainer":"style__deleteModelContainer___3nhfa","attachFloatButton":"style__attachFloatButton___3E-j4"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/moderator/ui/screens/scan-sticker/style.css
// module id = 1374
// module chunks = 0